import PropTypes from 'prop-types';
import { mapIndexed } from '@@serverHelpers/index.mjs';
import { isEmpty } from 'ramda';
import ClosedComponent from './ClosedComponent';
import { isRequired } from '@@viewValidations';
import { ControlledFileUpload } from '@@viewCommonComponents/controlled';
import { useProcess } from '@fasstech/oip-starter-utils/app';

const FilesUploadContainer = ({
  form,
  getMiddleText,
  deleteDocuments,
  documents,
  maxFileSize,
  uploadedFileLimit
}) => {
  const { context } = useProcess();
  return (
    <div className="grid md:grid-cols-2 gap-8 w-full my-4">
      {mapIndexed(({ label, files, filesType, group, required: groupRequired, icon }, index) => {
        return (
          <div key={`${filesType}-${index}`} className="w-full">
            {!isEmpty(group) ? (
              <ClosedComponent titleLabel={`${label}${groupRequired ? ' *' : ''}`} icon={icon}>
                <div className="grid grid-cols-1 gap-4">
                  {mapIndexed(
                    ({ label, files, filesType, required }, groupIndex) => (
                      <ControlledFileUpload
                        key={`${filesType}-${index}-${groupIndex}`}
                        index={index}
                        getMiddleText={getMiddleText}
                        deleteMutation={deleteDocuments}
                        name={`uploads.${index}.group.${groupIndex}.files`}
                        label={label}
                        filesType={filesType}
                        uploadedFiles={files}
                        {...form}
                        rules={required ? isRequired : {}}
                        maxFileSize={maxFileSize}
                        uploadedFileLimit={uploadedFileLimit}
                        accept={'.doc, .docx, image/jpeg, image/jpg, application/pdf'}
                        required={required}
                        projectId={context?.projectId}
                      />
                    ),
                    group
                  )}
                </div>
              </ClosedComponent>
            ) : (
              <ClosedComponent titleLabel={`${label}${groupRequired ? ' *' : ''}`} icon={icon}>
                <ControlledFileUpload
                  index={index}
                  getMiddleText={getMiddleText}
                  deleteMutation={deleteDocuments}
                  name={`uploads.${index}.files`}
                  label={label}
                  filesType={filesType}
                  uploadedFiles={files}
                  rules={groupRequired ? isRequired : {}}
                  {...form}
                  maxFileSize={maxFileSize}
                  uploadedFileLimit={uploadedFileLimit}
                  accept={'.doc, .docx, image/jpeg, image/jpg, application/pdf'}
                  required={groupRequired}
                  hideLabel={true}
                  projectId={context?.projectId}
                />
              </ClosedComponent>
            )}
          </div>
        );
      }, documents)}
    </div>
  );
};

FilesUploadContainer.propTypes = {
  form: PropTypes.object.isRequired,
  getMiddleText: PropTypes.func.isRequired,
  deleteDocuments: PropTypes.func.isRequired,
  documents: PropTypes.array.isRequired,
  maxFileSize: PropTypes.number.isRequired,
  uploadedFileLimit: PropTypes.number.isRequired
};

export default FilesUploadContainer;
